import EndcapBays from "./EndcapBays";
export default EndcapBays;
